export const approveUser = async (userID, setApproveUserStatusMessage) => {
  try {
    const response = await fetch(
      "https://wad-backend.ws381566.remote.ac/approveUser.php?adminRequired=true&userID=" + userID,
      {
        method: "DELETE",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
      }
    );

    const result = await response.json();

    if (result.status === "authenticationError") {
      window.location.href = "/login";
      return;
    }

    if (result.status === "success") {
      setApproveUserStatusMessage(result.message);
    } else {
      setApproveUserStatusMessage(result.message || "Failed to execute query");
    }
  } catch (error) {
    setApproveUserStatusMessage(error.message);
  }
};